/* The new-note card's shape, so the two things waiting for the patient look
 * like one family on Today. */
.card {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 18px 20px;
  background: var(--surface);
  border: var(--outline);
  border-radius: var(--radius-card);
  box-shadow: var(--shadow-card);
  color: var(--ink);
  text-decoration: none;
}

/* The accent dot says "new", as on the blueprint. */
.dot {
  flex: 0 0 auto;
  width: 10px;
  height: 10px;
  margin-top: 7px;
  border: 1.5px solid var(--ink);
  border-radius: 999px;
  background: var(--accent);
}

.lines {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}

.title {
  font-size: 16px;
  font-weight: 600;
}

.detail {
  font-size: 14px;
  color: var(--ink-2);
}

.chevron {
  flex: 0 0 auto;
  align-self: center;
  width: 18px;
  height: 18px;
  background-color: var(--ink-3);
  -webkit-mask: url('./chevron.svg') no-repeat center / contain;
  mask: url('./chevron.svg') no-repeat center / contain;
}
